const { getElements } = window.BAO.Utils

class HarperConcierge extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.observeSlides()
  }

  disconnectedCallback () {
    this.slidesObserver.disconnect()
  }

  setupListeners () {
    super.setupListeners()

    this.toggleHarper = this.toggleHarper.bind(this)

    if (this.els?.toggle.exists) {
      this.els.toggle.elements.forEach(el => {
        this.listeners.add(el, 'click', this.toggleHarper)
      })
    }

    this.closePopup = this.closePopup.bind(this)

    if (this.externalEls?.['close-popup']?.exists) {
      this.externalEls['close-popup'].elements.forEach(el => {
        this.listeners.add(el, 'click', this.closePopup)
      })
    }

    this.onShippingSelectorUpdate = this.onShippingSelectorUpdate.bind(this)

    window.addEventListener(
      'load',
      this.onShippingSelectorUpdate(this.dataset.market),
    )

    this.closeAllHarper = this.closeAllHarper.bind(this)

    this.listeners.add(document, 'drawerOpen', this.closeAllHarper)
  }

  onShippingSelectorUpdate (country) {
    this.setAttribute('aria-hidden', country.toLowerCase() !== 'gb')
  }

  closeAllHarper (e) {
    if (e?.detail?.key !== 'cart') return

    if (this.els?.item?.exists) {
      this.els.item.elements.forEach(el => {
        el.setAttribute('aria-hidden', 'true')
      })
    }

    this.closePopup()
  }

  closePopup () {
    if (this.externalEls?.popup?.exists) {
      this.externalEls.popup.elements.forEach(el => {
        el.setAttribute('aria-hidden', 'true')
      })

      if (this.externalEls?.['close-popup']?.exists) {
        this.externalEls['close-popup'].elements.forEach(el => {
          el.disabled = true
        })
      }
    }
  }

  togglePopup () {
    if (this.externalEls?.popup?.exists) {
      this.externalEls.popup.elements.forEach(el => {
        el.setAttribute(
          'aria-hidden',
          (el.getAttribute('aria-hidden') === 'false').toString(),
        )
      })

      if (this.externalEls?.['close-popup']?.exists) {
        this.externalEls['close-popup'].elements.forEach(el => {
          el.toggleAttribute('disabled')
        })
      }
    }
  }

  toggleHarper () {
    if (this.els?.item?.exists) {
      this.els.toggle.elements.forEach(el => {
        el.setAttribute(
          'aria-expanded',
          (el.getAttribute('aria-expanded') !== 'true').toString(),
        )
      })

      this.els.item.elements.forEach(el => {
        el.setAttribute(
          'aria-hidden',
          (el.getAttribute('aria-hidden') === 'false').toString(),
        )
      })

      if (this.els.item.element.getAttribute('aria-hidden') === 'true') {
        this.closePopup()
      }
    }
  }

  observeSlides () {
    this.slidesObserver = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          getElements('.open-harper-modal', { content: this }).forEach(el => {
            this.togglePopup = this.togglePopup.bind(this)
            this.listeners.add(el, 'click', this.togglePopup)
          })

          break
        }
      }
    })

    this.slidesObserver.observe(this.els.itemInner.element, { childList: true })
  }

  get userLocationName () {
    return `BAO-location-portrait`
  }
}

if (!customElements.get('harper-concierge')) {
  customElements.define('harper-concierge', HarperConcierge)
}
